export interface EditableSignatureRequest {
    formFieldType: EditableSignatureOrigin;
    formId: number;
    clientId: number;
    formFieldId: number;
    "data-order": number;
    value: string | null;
}

export enum EditableSignatureOrigin {
    CLIENT = 'SIGN_CLIENT',
    DOCTOR = 'SIGN_DOCTOR',
    LEGAL_REP = 'SIGN_LEGAL_REP',
}

export function isEditableSignatureRequest(obj: any): obj is EditableSignatureRequest {
    if (obj) {
        return (obj as EditableSignatureRequest).formFieldType !== undefined;
    }
    return false;
}
